import type { KPIRequest } from "@/types/kpiTypes.ts"

export const PLTHKPIs: KPIRequest[] = [
  {
    $type: "calc",
    name: "Raw Inlet Gas per Minute",
    unit: "SCFM",
    expression: "[60] / 1.44",
    aggFunction: "Average",
    location: 4,
  },
  {
    $type: "basic",
    id: 60,
    location: 4,
  },
  {
    $type: "basic",
    id: 65,
    location: 4,
    padding: 32,
  },
  {
    $type: "basic",
    id: 61,
    location: 4,
  },
  {
    $type: "calc",
    name: "Uptime",
    unit: "%",
    aggFunction: "Average",
    location: 4,
    expression: "[110]/24*100",
    padding: 32,
  },
  {
    $type: "calc",
    name: "Efficiency",
    unit: "%",
    aggFunction: "Average",
    typeId: 1,
    location: 4,
    preAggregate: true,
    expression: "[80] / ([61] * ([110] / 24)) * 100",
    padding: 32,
  },
  { $type: "basic", id: 80, location: 4 },
  { $type: "basic", id: 70, location: 4 },

  {
    $type: "basic",
    id: 55,
    location: 4,
  },
]
